<template>
  <div>
    <div class="video">
      <!-- 主持人 -->
      <share-player
        :class="activeVideo == 2 ? 'active' : ''"
        :cdbm="cdbm"
        v-if="showShare"
      />
      <div
        id="f_ocx"
        v-show="activeVideo == 1"
        :class="activeVideo == 1 ? 'active' : ''"
      >
        <video
          id="video"
          controls
          autoplay
          class="video-js vjs-default-skin"
          preload="auto"
          width="458px"
          height="270px"
          muted
          data-setup="{}"
        ></video>
      </div>
    </div>
    <div class="videoBtns">
      <div class="btn-video" v-for="(item, index) in btns" :key="index">
        <button
          :class="activeBtn == index ? 'active' : ''"
          type="button"
          @click="changeVideo(item.url, index)"
        >
          {{ item.text }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import videojs from "video.js";
import sharePlayer from "./sharePlayer.vue";
import WebSocketMixin from '../../mixins/WebSocketMixin';

export default {
  name: "myVideo",
  components: {
    sharePlayer,
  },
  computed: {
    showShare() {
      return this.cdbm;
    },
  },
  mixins: [WebSocketMixin],
  data() {
    return {
      btns: [],
      activeBtn: 0,
      cdbm: "", //
      player: null,
      activeVideo: 2,
      bdId: "",
      controlStatus: 1, // 1:已开启 2:已关闭
    };
  },
  watch: {
    controlStatus(val) {
      if (val == 2) {
        this.$message.info("开标已结束，直播即将关闭！");
        setTimeout(() => {
          window.close();
        }, 2000);
      }
    },
  },
  methods: {
    changeVideo(url, index) {
      console.log("--222-", url, index);
      if (index == 0) {
        this.activeVideo = 2;
      } else {
        this.activeVideo = 1;
      }
      this.player.src([
        {
          type: "application/x-mpegURL",
          src: url,
        },
      ]);
      this.player.load();
      setTimeout(() => {
        const videoElement = this.$el.querySelector("#video_html5_api");
        const src = videoElement.src;
        if (src == "") {
          let url = window.location.href;
          let newUrl = "";
          if (this.$route.query.newParam) {
            url = url.replace(
              `newParam=${this.$route.query.newParam}`,
              `newParam=${index}`
            );
          } else {
            const separator = url.indexOf("?") > -1 ? "&" : "?";
            newUrl = url + separator + `newParam=${index}`;
          }
          window.location.href = newUrl;
        }
      }, 1000);

      this.activeBtn = index;
    },
    //获取摄像头参数
    getSxt() {
      this.btns = [];
      this.$api
        .getSxtAndLive(this.bdId)
        .then((res) => {
          if (res.data.meta.success) {
            this.controlStatus=res.data.data.controlStatus; // 1:已开启 2:已关闭

            var src=window.btoa(res.data.data.zcrBfdz)
            if(!src){
              this.$message.error('播放地址不能为空')
            }else{
              this.cdbm = 'https://ztxrtc.zhaotx.cn/tcPlayer?streamName='+src;
            }
            if (res.data.data.sxtdz) {
              let sxtdz = res.data.data.sxtdz.split(",");
              sxtdz.forEach((item, index) => {
                if (index == 0) {
                  this.btns.push({ text: "主持人桌面", url: item });
                } else {
                  var i = index + 1;
                  this.btns.push({ text: "摄像头" + i, url: item });
                }
              });
              this.getVideo(sxtdz[0]);
              if (this.$route.query.newParam) {
                let index = this.$route.query.newParam;
                this.changeVideo(this.btns[index].url, index);
              }
            }
          }
        })
        .catch(() => {});
    },
    getVideo(src) {
      this.activeVideo = 2;
      this.player = videojs("video", {
        bigPlayButton: false,
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true,
        preload: "auto",
        autoplay: true,
        controls: true,
        sources: [
          {
            src: src,
            type: "application/x-mpegURL",
          },
        ],
      });
    },

    // 重写 WebSocket 消息处理方法
    webSocketMessage(obj) {
      console.log('WebSocket message:', obj);
      let lx = obj.lx;
      if (lx == 'kbjshzz') {
        console.log('开标结束，关闭直播通道！');
        this.controlStatus = 2;
      }
    },
  },
  mounted() {
    this.bdId = this.$route.query.bdId;
    this.getSxt();

    // 初始化 WebSocket 参数
    this.wsParams = { bdId: this.$route.query.bdId };
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="less">
.iframe {
  width: 100%;
  height: 100%;
}
.video-dimensions {
  overflow: hidden;
  width: 100% !important;
  height: 100% !important;
  video {
    width: 100%;
    height: 100%;
  }
}
.video {
  width: 100%;
  height: 80%;
  background: #333;
  position: relative;
  #f_ocx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    background: #333;
  }
  #f_ocx.active {
    visibility: initial;
  }
  #f_ocx2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
    //visibility: hidden;
  }
  #f_ocx2.active {
    visibility: initial;
  }
}
.videoBtns {
  margin: 20px 10px 0 20px;
  display: flex;
  .btn-video {
    flex: 1;
    margin-right: 10px;
  }
  button {
    height: 45px;
    line-height: 45px;
    background: #404040;
    color: #fff;
    font-size: 16px;
    width: 100%;
  }
  button.active {
    background: @base-color;
    font-weight: bold;
  }
}
</style>